import { render, staticRenderFns } from "./FrmTimeTip.vue?vue&type=template&id=16552322&scoped=true"
import script from "./FrmTimeTip.vue?vue&type=script&lang=js"
export * from "./FrmTimeTip.vue?vue&type=script&lang=js"
import style0 from "./FrmTimeTip.vue?vue&type=style&index=0&id=16552322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16552322",
  null
  
)

export default component.exports